import { getImageAsBase64 } from "./components/getImageAsBase64";

const getDownloadImage = async (value: RequestInfo) => {
    return await getImageAsBase64(value);
};

export default getDownloadImage;
